import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppRouteConstants } from 'src/app/core/constants/AppRouteConstants';

import { AsstntSrchComponent } from './asstnt-srch/asstnt-srch.component';
import { AsstntSrchResultsComponent } from './asstnt-srch-results/asstnt-srch-results.component';
import { AsstntSrchActHomeComponent } from './asstnt-srch-act-home/asstnt-srch-act-home.component';
import { PiiShareAsstntComponent } from './pii-share-asstnt/pii-share-asstnt.component';
import { ConfirmAsstntComponent } from './confirm-asstnt/confirm-asstnt.component';
import { PostConfInstrAsstntComponent } from './post-conf-instr-asstnt/post-conf-instr-asstnt.component';


const routes: Routes = [
  {path: AppRouteConstants.ASST_SEARCH , component : AsstntSrchComponent},
  {path: AppRouteConstants.ASST_SEARCH_RESULTS , component : AsstntSrchResultsComponent},
  {path: AppRouteConstants.ASST_SEARCH_ACT_CONFIRM , component : AsstntSrchActHomeComponent},
  {path:AppRouteConstants.ASST_SEARCH_CONFIRM, component:ConfirmAsstntComponent},
  // {path:AppRouteConstants.ASST_PII_SHARE, component:PiiShareAsstntComponent},
  {path:AppRouteConstants.ASST_SEARCH_POST_CONFIRM,component:PostConfInstrAsstntComponent}


 ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AstSrchRoutingModule { }
